import Cookies from 'js-cookie'

export function getLocalItem(TokenKey) {
  return localStorage.getItem(TokenKey)
}

export function setLocalItem(TokenKey, token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeLocalItem(TokenKey) {
  return localStorage.removeItem(TokenKey)
}

export function getCookie(cookie) {
  return Cookies.get(cookie)
}

// 每次请求读取最新登录态，兼容旧登录方式并避免重复添加 Bearer 前缀。
export function getAuthHeaders() {
  const normalize = (value) => typeof value === 'string'
    ? value.trim().replace(/^Bearer\s+/i, '').trim()
    : ''
  let token = normalize(getLocalItem('access_token')) || normalize(getCookie('token'))
  if (!token) {
    try {
      const userInfo = JSON.parse(getLocalItem('useInfo') || 'null')
      token = normalize(userInfo?.access_token) || normalize(userInfo?.token)
    } catch {
      // 损坏的旧用户信息按未登录处理。
    }
  }
  return token ? { 'X-Auth-Token': `Bearer ${token}` } : {}
}

export function setCookie(key, value) {
  return Cookies.set(key, value)
}
